import { FaxSentStatus } from "../../../enums/faxStatus";

/**
 * Maps fax submission status to the correct order status
 * @param status - The fax sent status
 * @returns The corresponding order status
 */
export const getCorrectStatusBasedOnFaxSubmissionStatus = (
  status: string,
): string => {
  if (status === FaxSentStatus.SENT) {
    return "completed";
  } else if (status === FaxSentStatus.FAILED) {
    return "error";
  } else {
    return "in_progress";
  }
};
